import { render, staticRenderFns } from "./TeamTop.vue?vue&type=template&id=e116f8da&scoped=true"
import script from "./TeamTop.vue?vue&type=script&lang=js"
export * from "./TeamTop.vue?vue&type=script&lang=js"
import style0 from "./TeamTop.vue?vue&type=style&index=0&id=e116f8da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e116f8da",
  null
  
)

export default component.exports